import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../components/Navbar";
import { BASE_URL } from "../../../const";

const BATCH_URL = `${BASE_URL}/batches/`;
const SKU_URL = `${BASE_URL}/get-top-skus/`;

export default function BatchExplorer() {
  const navigate = useNavigate();

  /* ---------------- state ---------------- */
  const [batches, setBatches] = useState([]);
  const [topSkus, setTopSkus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);

  const [warehouse, setWarehouse] = useState(localStorage.getItem("selectedWarehouse"));
  const [isAdmin, setIsAdmin] = useState(false);
  const [activeImage, setActiveImage] = useState(null);


  const [spaceStatus, setSpaceStatus] = useState("occupied");
  const [skuSearch, setSkuSearch] = useState("");
  const [skuMap, setSkuMap] = useState({});
  
  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
    plant_sku: [],
  });

  useEffect(() => {
    fetch(SKU_URL, { headers: authHeaders() })
      .then(res => res.json())
      .then(data => {
        const list = data.top_skus || [];
        setTopSkus(list);

        const map = {};
        list.forEach(s => {
          map[s.sku] = s.sku_name;
        });
        setSkuMap(map);
      })
      .catch(console.error);
    
    const store = localStorage.getItem("store");
    if (store === "admin") {
      setIsAdmin(true);
    }
  }, []);

  /* ---------------- helpers ---------------- */
  const authHeaders = () => {
    const token = localStorage.getItem("token") || "";
    return {
      Authorization: token ? `Token ${token}` : "",
      "Content-Type": "application/json",
    };
  };

  const ageInDays = (dateStr) =>
    Math.floor((new Date() - new Date(dateStr)) / (1000 * 60 * 60 * 24));

  /* ---------------- fetch SKUs ---------------- */
  useEffect(() => {
    fetch(SKU_URL, { headers: authHeaders() })
      .then(res => res.json())
      .then(data => setTopSkus(data.top_skus || []))
      .catch(console.error);
  }, []);

  /* ---------------- fetch batches ---------------- */
  const fetchBatches = async (url = null) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (warehouse) params.append("warehouse", warehouse);
      if (filters.start_date) params.append("start_date", filters.start_date);
      if (filters.end_date) params.append("end_date", filters.end_date);
      if (spaceStatus) params.append("space_status", spaceStatus);


      filters.plant_sku.forEach(s => params.append("plant_sku", s));

      const fetchUrl = url || `${BATCH_URL}?${params.toString()}`;
      const res = await fetch(fetchUrl, { headers: authHeaders() });
      const json = await res.json();

      setBatches(json.results || []);
      setNextUrl(json.next);
      setPrevUrl(json.previous);
    } catch (e) {
      console.error(e);
      setBatches([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (warehouse) fetchBatches();
  }, [warehouse]);

  /* ---------------- UI ---------------- */
  return (
    <>
      <Navbar />
      <div className="max-w-7xl mx-auto p-4 bg-gray-50 min-h-screen space-y-4">

        {/* ---------- Header ---------- */}
        <div className="bg-white rounded-xl border p-4 flex justify-between items-center">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Batch Explorer</h2>
            <p className="text-xs text-gray-500 mt-1">
              View and inspect batches warehouse-wise
            </p>
          </div>

          <div className="flex gap-3 items-center">
            {isAdmin && (
              <select
                value={warehouse}
                onChange={(e) => {
                  setWarehouse(e.target.value);
                  localStorage.setItem("selectedWarehouse", e.target.value);
                }}
                className="border px-3 py-2 rounded text-sm"
              >
                <option value="pune">Pune Warehouse</option>
                <option value="kolkata">Kolkata Warehouse</option>
              </select>
            )}
            <button
              onClick={() => navigate(-1)}
              className="px-3 py-2 bg-gray-800 text-white rounded text-sm font-semibold"
            >
              Back
            </button>
          </div>
        </div>
        {/* ---------- Filters ---------- */}
        <div className="bg-white rounded-xl border p-4 space-y-4">

          {/* Dates */}
          <div className="grid grid-cols-4 gap-4">
            <div>
              <label className="text-xs text-gray-600">Start Date</label>
              <input
                type="date"
                className="border rounded px-2 py-1 text-sm w-full"
                onChange={e => setFilters({ ...filters, start_date: e.target.value })}
              />
            </div>

            <div>
              <label className="text-xs text-gray-600">End Date</label>
              <input
                type="date"
                className="border rounded px-2 py-1 text-sm w-full"
                onChange={e => setFilters({ ...filters, end_date: e.target.value })}
              />
            </div>

            <div>
              <label className="text-xs text-gray-600">Space Status</label>
              <select
                value={spaceStatus}
                onChange={e => setSpaceStatus(e.target.value)}
                className="border rounded px-2 py-1 text-sm w-full"
              >
                <option value="occupied">Occupied</option>
                <option value="free">Free</option>
              </select>
            </div>
          </div>

{/* Plant Search + Select */}
{/* Plant Search + Select */}
<div className="col-span-4">
  <label className="text-xs text-gray-600">Plants</label>

  <input
    placeholder="Search plant..."
    value={skuSearch}
    onChange={e => setSkuSearch(e.target.value)}
className="border rounded px-2 py-1 text-sm w-full mb-2 focus:outline-none focus:ring-1 focus:ring-blue-500"
  />

  <div className="border rounded max-h-40 overflow-y-auto p-0 flex flex-col">
    {topSkus
      .filter(s =>
        s.sku_name.toLowerCase().includes(skuSearch.toLowerCase())
      )
      .map(s => (
        <label
          key={s.sku}
          className="flex items-center justify-start gap-2 px-2 py-1.5 text-sm hover:bg-gray-100 cursor-pointer w-full"
        >
          <input
            type="checkbox"
            className="shrink-0"
            checked={filters.plant_sku.includes(s.sku)}
            onChange={() => {
              setFilters(prev => ({
                ...prev,
                plant_sku: prev.plant_sku.includes(s.sku)
                  ? prev.plant_sku.filter(x => x !== s.sku)
                  : [...prev.plant_sku, s.sku],
              }));
            }}
          />
          <span className="truncate text-left flex-1">{s.sku_name}</span>
        </label>
      ))}
  </div>
</div>


          <button
            onClick={() => fetchBatches()}
            className="bg-blue-600 text-white py-2 rounded text-sm font-semibold w-full"
          >
            Apply Filters
          </button>
        </div>


        {/* ---------- Table Header ---------- */}
        <div className="grid grid-cols-6 px-4 text-xs font-semibold text-gray-600">
          <div>Batch ID</div>
          <div>Total Qty</div>
          <div>Available Qty</div>
          <div>Age (days)</div>
          <div>Images</div>
          <div></div>
        </div>

        {/* ---------- Rows ---------- */}
        {loading ? (
          <div className="text-center py-10 text-sm text-gray-500">Loading batches…</div>
        ) : batches.length === 0 ? (
          <div className="text-center py-10 text-sm text-gray-500">No batches found</div>
        ) : (
          <div className="space-y-2">
            {batches.map(b => (
              <div key={b.batch_id} className="bg-white border rounded-lg">
                <div
                  onClick={() => setExpanded(expanded === b.batch_id ? null : b.batch_id)}
                  className="grid grid-cols-6 px-4 py-3 text-sm cursor-pointer hover:bg-gray-50"
                >
                  <div className="font-medium leading-tight">
                    {b.batch_id}
                    <div className="text-xs text-gray-500 mt-0.5 truncate">
                      {skuMap[b.plant_sku] || b.plant_sku}
                      
                    </div>
                  </div>
                  <div>{b.total_qty}</div>
                  <div>{b.avl_qty}</div>
                  <div>{ageInDays(b.created_at)}</div>
                  <div>{b.images.length}</div>
                  <div className="text-right text-blue-600 text-xs font-semibold">
                    View
                  </div>
                </div>

                {expanded === b.batch_id && (
                <div className="border-t p-4 space-y-3">
                  <div className="grid grid-cols-2 gap-3 text-sm text-gray-700">
                    <div><b>Warehouse:</b> {b.warehouse}</div>
                    <div><b>Created At:</b> {b.created_at}</div>
                    <div><b>Layer:</b> {b.layer_type}</div>
                    <div><b>Total Qty:</b> {b.total_qty}</div>
                    <div><b>Location:</b> {b.row_loc} - {b.section_loc}</div>
                    <div><b>Space Status:</b> {b.space_status}</div>
                    
                    <div>
                      <b>Plant:</b> {b.plant_sku} – {skuMap[b.plant_sku]}
                    </div>
                  </div>
                  <div className="grid grid-cols-4 gap-2">
                      {b.images.map(img => (
                        <img
                          key={img.id}
                          src={img.image}
                          onClick={() => setActiveImage(img.image)}
                          className="h-32 w-full object-cover rounded border cursor-pointer hover:opacity-90"
                          alt=""
                        />
                      ))}
                    </div>


                  {activeImage && (
                    <div
                      className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center"
                      onClick={() => setActiveImage(null)}
                    >
                      {/* Close button */}
                      <button
                        onClick={() => setActiveImage(null)}
                        className="absolute top-4 right-4 text-white text-2xl font-bold"
                      >
                        ×
                      </button>

                      {/* Image */}
                      <img
                        src={activeImage}
                        onClick={(e) => e.stopPropagation()}
                        className="max-h-[90vh] max-w-[90vw] object-contain rounded"
                        alt=""
                      />
                    </div>
                  )}

                </div>

                )}
              </div>
            ))}
          </div>
        )}

        {/* ---------- Pagination ---------- */}
        <div className="flex justify-between pt-4">
          <button
            disabled={!prevUrl}
            onClick={() => fetchBatches(prevUrl)}
            className="px-4 py-2 border rounded disabled:opacity-40 text-sm"
          >
            Previous
          </button>
          <button
            disabled={!nextUrl}
            onClick={() => fetchBatches(nextUrl)}
            className="px-4 py-2 border rounded disabled:opacity-40 text-sm"
          >
            Next
          </button>
        </div>

      </div>
    </>
  );
}
